import React from 'react'
import moment from 'moment'

import type {
  CalendarApiDayData,
  CalendarApiEventData,
} from '../../store/calendar'
import { getBookingURL } from '../../utils/Utils'

// Helpers for event display
const getEventName = (event: CalendarApiEventData): string => {
  let name = window.jsProps.lang === 'de' ? event.nameDe : event.nameEn
  if (window.jsProps.eventsById[event.eventTyp]) {
    name = window.jsProps.eventsById[event.eventTyp].title
  }
  return name
}

const getEventDescription = (event: CalendarApiEventData): string => {
  let desc = ''
  if (window.jsProps.eventsById[event.eventTyp]) {
    desc = window.jsProps.eventsById[event.eventTyp].description
  }
  return desc
}

// ─── Day Component ──────────────────────────────────────────
export default function Day({
  day,
  info,
  selected,
  onEventClick,
}: {
  day: {
    date: moment.Moment
    isCurrentMonth: boolean
    isToday: boolean
    number: number
  }
  info: CalendarApiDayData
  selected: moment.Moment
  onEventClick: (event: { headline: string; text: string; url: string }) => void
}) {
  const { date, isToday, isCurrentMonth, number } = day

  return (
    <div
      key={date.toString()}
      className={
        'CalendarElement__Day CalendarDay' +
        (isToday ? ' today' : '') +
        (isCurrentMonth ? '' : ' different-month') +
        (date.isSame(selected) ? ' selected' : '')
      }
    >
      <div className="CalendarDay__Content">
        <div className="CalendarDay__Meta">
          <div className="CalendarDay__DayNumber">{number}</div>
          <div className="CalendarDay__DayName">
            {moment(date).format('dddd')}
          </div>
          {isToday && (
            <div className="CalendarDay__TodayLabel">
              {window.jsProps.strings.today}
            </div>
          )}
          {info && (
            <div className="CalendarDay__OpeningHours">
              {info.from} - {info.to}
            </div>
          )}
        </div>

        {day.date.diff(moment(), 'days') >= 0 && (
          <div className="CalendarDay__Events">
            {info?.events && info.events.length > 0 && (
              <div
                className="CalendarDay__Event"
                onClick={() =>
                  onEventClick({
                    headline: getEventName(info.events[0]),
                    text: getEventDescription(info.events[0]),
                    url: getBookingURL(day.date.format('YYYY-MM-DD'), true),
                  })
                }
              >
                <div className="CalendarDay__EventType">
                  {window.jsProps.strings.specialEvent}
                </div>
                <div className="CalendarDay__EventName">
                  {getEventName(info.events[0])}
                </div>
              </div>
            )}
          </div>
        )}

        {day.date.diff(moment(), 'days') >= 0 && (
          <div className="CalendarDay__CtaContainer">
            <div className="CalendarDay__Cta">
              <a
                href={getBookingURL(day.date.format('YYYY-MM-DD'), false)}
                target="_blank"
                rel="noreferrer"
              >
                {window.jsProps.strings.bookNow}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
